"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Loudspeaker = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactGa = _interopRequireDefault(require("react-ga"));

var _reactComponents = require("@cimpress/react-components");

var _reactI18next = require("react-i18next");

var _i18n = _interopRequireDefault(require("../i18n/i18n"));

var _loadGa = require("../ga/loadGa");

var _loudspeakerclient = _interopRequireDefault(require("../clients/loudspeakerclient"));

var _customizrclient = _interopRequireDefault(require("../clients/customizrclient"));

var _LoudspeakerHeader = _interopRequireDefault(require("./LoudspeakerHeader"));

var _LoudspeakerList = _interopRequireDefault(require("./LoudspeakerList"));

var _LoudspeakerFooter = _interopRequireDefault(require("./LoudspeakerFooter"));

require("../styles/loudspeaker.css");

var Loudspeaker =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Loudspeaker, _React$Component);

  function Loudspeaker(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Loudspeaker);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Loudspeaker).call(this, props));
    (0, _loadGa.loadGoogleAnalytics)();
    _this.state = {
      isVisible: false,
      remoteAnnouncements: [],
      initializedTimestamp: new Date().getTime()
    };
    var _this$props = _this.props,
        accessToken = _this$props.accessToken,
        channelId = _this$props.channelId,
        language = _this$props.language; // Set the translation of the component and any announcements

    _i18n.default.changeLanguage(language); // Initialize the clients if we have the necessary props


    if (accessToken && channelId) {
      _this.loudspeakerClient = new _loudspeakerclient.default({
        accessToken: accessToken,
        channelId: channelId
      });
      _this.customizrClient = new _customizrclient.default({
        accessToken: accessToken,
        channelId: channelId
      });
    }

    _this.closeModal = _this.closeModal.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.dismissAnnouncements = _this.dismissAnnouncements.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.onRemind = _this.onRemind.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    return _this;
  }

  (0, _createClass2.default)(Loudspeaker, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee() {
        var announcements, timestamp, remoteAnnouncements, initializedTimestamp, modalOpenedTimestamp;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _reactGa.default.ga('create', 'UA-92106163-5', 'auto', 'reactLoudspeaker');

                announcements = this.props.announcements;

                if (!(!announcements && this.customizrClient && this.loudspeakerClient)) {
                  _context.next = 10;
                  break;
                }

                _context.next = 5;
                return this.customizrClient.getLastAcknowledgementTimestamp();

              case 5:
                timestamp = _context.sent;
                _context.next = 8;
                return this.loudspeakerClient.getAnnouncements({
                  after: timestamp
                });

              case 8:
                remoteAnnouncements = _context.sent; // Avoid setting the state if the clients have been cancelled. This means this component has either
                // unmounted or is in the process of unmounting.

                if (!this.customizrClient.isCancelled() && !this.loudspeakerClient.isCancelled()) {
                  this.setState({
                    remoteAnnouncements: remoteAnnouncements,
                    isVisible: !!remoteAnnouncements.length
                  });

                  if (remoteAnnouncements.length > 0) {
                    initializedTimestamp = this.state.initializedTimestamp;
                    modalOpenedTimestamp = new Date().getTime();

                    _reactGa.default.ga('reactLoudspeaker.send', 'pageview', window.location.pathname);

                    _reactGa.default.ga('reactLoudspeaker.send', 'event', 'reactLoudspeaker', 'Modal opened');

                    _reactGa.default.ga('reactLoudspeaker.send', 'timing', 'reactLoudspeaker', 'Modal opened', modalOpenedTimestamp - initializedTimestamp);
                  }
                }

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      };
    }()
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var language = this.props.language;

      if (language !== prevProps.language) {
        // Set the translation of the component and any announcements
        _i18n.default.changeLanguage(language);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Send a cancel signal to our clients
      if (this.customizrClient && this.loudspeakerClient) {
        this.customizrClient.cancel();
        this.loudspeakerClient.cancel();
      }
    }
  }, {
    key: "onRemind",
    value: function onRemind() {
      var initializedTimestamp = this.state.initializedTimestamp;
      var clickedRemindLaterTimestamp = new Date().getTime();

      _reactGa.default.ga('reactLoudspeaker.send', 'event', 'reactLoudspeaker', 'Clicked remind later');

      _reactGa.default.ga('reactLoudspeaker.send', 'timing', 'reactLoudspeaker', 'Clicked remind later', clickedRemindLaterTimestamp - initializedTimestamp);

      this.closeModal();
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      var onRequestHide = this.props.onRequestHide;
      this.setState({
        isVisible: false
      });

      if (onRequestHide) {
        onRequestHide();
      }
    }
  }, {
    key: "dismissAnnouncements",
    value: function dismissAnnouncements() {
      var initializedTimestamp = this.state.initializedTimestamp;
      var dismissedModalTimestamp = new Date().getTime();

      _reactGa.default.ga('reactLoudspeaker.send', 'event', 'reactLoudspeaker', 'Dismissed modal');

      _reactGa.default.ga('reactLoudspeaker.send', 'timing', 'reactLoudspeaker', 'Dismissed modal', dismissedModalTimestamp - initializedTimestamp);

      if (this.customizrClient) {
        this.customizrClient.acknowledgeAnnouncements();
      }

      this.closeModal();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          isVisible = _this$state.isVisible,
          remoteAnnouncements = _this$state.remoteAnnouncements,
          initializedTimestamp = _this$state.initializedTimestamp;
      var _this$props2 = this.props,
          title = _this$props2.title,
          forceShow = _this$props2.forceShow,
          showRobot = _this$props2.showRobot,
          announcements = _this$props2.announcements,
          hideViewAllAnnouncementsButton = _this$props2.hideViewAllAnnouncementsButton,
          channelId = _this$props2.channelId,
          language = _this$props2.language,
          defaultFallbackLanguage = _this$props2.defaultFallbackLanguage,
          t = _this$props2.t;
      var announcementsList = announcements || remoteAnnouncements;
      var show = forceShow !== undefined ? forceShow : isVisible; // If we're using local announcements then we don't have a channel ID to point to in Loudspeaker
      // and the show all announcements button should be hidden. Same if the host app has requested it be removed.

      var isViewAllAnnouncementsButtonDisabled = !!announcements || hideViewAllAnnouncementsButton;

      var footer = _react.default.createElement(_LoudspeakerFooter.default, {
        onRemind: this.onRemind,
        onDismiss: this.dismissAnnouncements,
        t: t
      });

      return _react.default.createElement(_reactComponents.Modal, {
        className: "loudspeakerModal",
        show: show,
        bsStyle: "info",
        onRequestHide: this.dismissAnnouncements,
        footer: footer,
        closeButton: true,
        closeOnOutsideClick: true
      }, _react.default.createElement("div", {
        className: "loudspeaker"
      }, _react.default.createElement(_LoudspeakerHeader.default, {
        title: title,
        showRobot: showRobot
      }), _react.default.createElement(_LoudspeakerList.default, {
        announcements: announcementsList,
        hideViewAllAnnouncementsButton: isViewAllAnnouncementsButtonDisabled,
        channelId: channelId,
        language: language,
        defaultFallbackLanguage: defaultFallbackLanguage,
        initializedTimestamp: initializedTimestamp,
        t: t
      })));
    }
  }]);
  return Loudspeaker;
}(_react.default.Component);

exports.Loudspeaker = Loudspeaker;
Loudspeaker.propTypes = {
  accessToken: _propTypes.default.string,
  channelId: _propTypes.default.string,
  showRobot: _propTypes.default.bool,
  title: _propTypes.default.string.isRequired,
  hideViewAllAnnouncementsButton: _propTypes.default.bool,
  announcements: _propTypes.default.arrayOf(_propTypes.default.shape({
    announcementId: _propTypes.default.string,
    channelId: _propTypes.default.string,
    content: _propTypes.default.shape({
      en: _propTypes.default.string,
      de: _propTypes.default.string,
      fr: _propTypes.default.string
    }).isRequired,
    snippet: _propTypes.default.shape({
      en: _propTypes.default.string,
      de: _propTypes.default.string,
      fr: _propTypes.default.string
    }),
    title: _propTypes.default.shape({
      en: _propTypes.default.string,
      de: _propTypes.default.string,
      fr: _propTypes.default.string
    }),
    tags: _propTypes.default.arrayOf(_propTypes.default.shape({
      key: _propTypes.default.string,
      value: _propTypes.default.string
    })),
    createdBy: _propTypes.default.string,
    creationDate: _propTypes.default.string,
    lastModifiedDate: _propTypes.default.string,
    expirationDate: _propTypes.default.string
  })),
  forceShow: _propTypes.default.bool,
  onRequestHide: _propTypes.default.func,
  language: _propTypes.default.string,
  defaultFallbackLanguage: _propTypes.default.string,
  t: _propTypes.default.func.isRequired
};
Loudspeaker.defaultProps = {
  accessToken: '',
  channelId: '',
  showRobot: true,
  announcements: undefined,
  forceShow: undefined,
  onRequestHide: undefined,
  hideViewAllAnnouncementsButton: false,
  language: 'en',
  defaultFallbackLanguage: 'en'
};

var _default = (0, _reactI18next.withNamespaces)('loudspeaker')(Loudspeaker);

exports.default = _default;